import { Stack } from "@fluentui/react";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { buildComplementaryDocumentsColumns } from "./fields/ComplementaryDocuments.columns";
import { buildComplementaryDocumentsFilters } from "./fields/ComplementaryDocuments.filters";

import { FilterParamsType } from "@/common/types/ListFromApi.types";
import { Card } from "@/components/Shared/Card";
import { useGetServices } from "@/core/libs/api/react-query/hook/use-get-services";
import { useGetTerms } from "@/core/libs/api/react-query/hook/use-get-terms";
import { ListData } from "@/core/libs/list-data/lib";
import { useURLFilter } from "@/hooks/useUrlFilter";
import { formatToSelect } from "@/utils/FormatToSelect";

function ListComplementaryDocuments(): JSX.Element {
  const { changeUrlParams, urlParams } = useURLFilter();
  const { termsList, isLoadingTermsList } = useGetTerms({
    params: { ...urlParams.params, termType: "CHANGE_OF_OWNERSHIP" },
    urlString: "terms"
  });

  const { servicesList, isLoadingServicesList } = useGetServices({
    method: "GET"
  });

  const servicesFormatted = formatToSelect(servicesList);
  const navigate = useNavigate();

  const handleAccountRequest = useCallback(
    (filterParams?: FilterParamsType) => {
      changeUrlParams(filterParams);
    },
    [changeUrlParams]
  );

  return (
    <Stack styles={{ root: { width: "100%" } }}>
      <Helmet>
        <title>Documentos Complementares - Libertas</title>
      </Helmet>

      <Stack tokens={{ childrenGap: 15 }}>
        <h2 className="ms-fontSize-24">Documentos Complementares</h2>
        <Card>
          <ListData
            headerAction={undefined}
            headerText="Documentos Complementares"
            isLoadingList={isLoadingTermsList}
            items={termsList || []}
            columns={buildComplementaryDocumentsColumns({
              hasActions: false,
              navigate
            })}
            menuItems={termsList}
            _paginate={handleAccountRequest}
            filters={buildComplementaryDocumentsFilters({
              servicesList: servicesFormatted,
              isLoadingServicesList
            })}
            hasFilters
            isDefaultFilterVisible
          />
        </Card>
      </Stack>
    </Stack>
  );
}

export default ListComplementaryDocuments;
